import "./App.css";
import { Rutas } from "./Rutas";

function App() {
  return <Rutas />;
}

export default App;
